import http from "api/https";

export const getUserAccountMe = (): Promise<any> => {
  return http.get("/UserAccount/GetMe");
};

export const getMyProfile = (): Promise<any> => {
  return http.get("/UserAccount/GetMyProfile");
};

// Получить всех пользователей
export const getuser_accounts = (): Promise<any> => {
  return http.get("/UserAccount/GetAll");
};

// Получить пользователей по ID организации
export const getuser_accountsByOrganization = (organization_id: number): Promise<any> => {
  return http.get(`/UserAccount/GetByOrganization?id=${organization_id}`);
};

// Получить одного пользователя по ID
export const getuser_account = (id: number): Promise<any> => {
  return http.get(`/UserAccount/GetOneById?id=${id}`);
};

// Создать нового пользователя
export const createuser_account = (data: any): Promise<any> => {
  return http.post("/UserAccount/Create", data);
};

// Обновить пользователя
export const updateuser_account = (data: any): Promise<any> => {
  return http.put(`/UserAccount/Update`, data);
};

export const updateUserProfile = (data: any): Promise<any> => {
  return http.put(`/UserAccount/UpdateProfile`, data);
};

// Удалить пользователя
export const deleteuser_account = (id: number): Promise<any> => {
  return http.remove(`/UserAccount/Delete?id=${id}`,{});
};

// Получить пагинированных пользователей
export const getuser_accountsPaginated = (pageSize: number, pageNumber: number): Promise<any> => {
  return http.get(`/UserAccount/GetPaginated?pageSize=${pageSize}&pageNumber=${pageNumber}`);
};